import { extend } from 'vee-validate';
import { ValidationRule } from 'vee-validate/dist/types/types';

export function addRules(rules: Record<string, ValidationRule>) {
  Object.entries(rules).forEach(([key, value]) => extend(key, value));
}
